module.exports = __webpack_public_path__ + "img/service-express.2edb235.png";